import { addCss } from '@zk/framework-vue';
import { createDriver, resetDriversByNS } from '@zk/framework-vue';
const SCOPED_NAME = 'close-module-driver';

const insertCurrentCss = (options) => {
  return addCss(SCOPED_NAME, (name) => (`
  .driver-fix-index{
    overflow: hidden;
  }
  .driver-fix-index #app .fixed-header.driver-fix-stacking{
    position: absolute;
  }
  #help_center_close-module-guide.driver-highlighted-element{
    background: var(--primary-color);
  }
  #driver-popover-item.guide-card-close-popover{
    transform: translateX(4px);
  }
  #driver-popover-item.guide-card-close-popover .driver-popover-title{
    display:none;
  }

  div#driver-highlighted-element-stage {
    background-color: unset!important;
    animation: none!important;
    border: none!important;
  }
  .${name} div#driver-popover-item .driver-popover-tip.left {
    border-color: transparent rgb(111, 109, 237) transparent transparent;
  }
  #help_center_close-module-guide.driver-highlighted-element {
    border: 2px solid var(--primary-color);
    animation: 3s infinite linear scaleBoxShadow;
    border-radius: 50%;
  }
  #help_center_close-module-guide.driver-highlighted-element .zkicon{
    color: #fff;
  }
  /* .driver-highlighted-element{
    border: 2px solid #4C95FF;
    animation: 3s infinite linear scaleBoxShadow;
  }*/
  div#driver-popover-item.${name} {
    padding: var(--m-large);
    padding-bottom: 16px;
    // background: #FFF !important;
    width: 333px;
    // background-color: #fff;
    border-radius: 6px;
    // background-image: radial-gradient(
    //   circle at 0 0,
    //   rgba(99, 96, 230, 0.15) 0px,
    //   #fff 100px
    // ) !important;
    background: rgb(111, 109, 237);
  }
  div#driver-popover-item.${name}::before {
    content: '';
    border-radius: 6px;
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 0;
    background: inherit;
    z-index: -1;
  }
  div#driver-popover-item.${name} .driver-popover-footer {
    padding: 0;
    // margin-top:24px;
    margin-top: 16px;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-btn{
    display: none;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-only-btn{
    display: inline-block;
  }
  div#driver-popover-item.${name} .driver-popover-footer button {
    border-radius: var(--radius-mini);
    border: 0px solid #fff;
    // background: var(--primary-color);
    background: #fff;
    // color: #FFF ;
    color: var(--primary-color);
    padding: 4px 16px;
    font-size: 12px !important;
    height: 32px;
    text-shadow: initial !important;
    box-shadow: 0px 2px 10px 2px rgba(99, 96, 230, 0.16);
    border-radius: 16px;
  }
  div#driver-popover-item.${name} .driver-popover-footer button:hover {
    // color: var(--font-color-5) !important;
    // background-color: var(--brand-color-6);
    // border-color: var(--brand-color-6);
  }
  div#driver-popover-item .driver-popover-title {
    font-weight: var(--weight-font-Blod);
    color: #FFFFFF !important;
    line-height: 24px;
    font-size: 18px;
  }
  div#driver-popover-item .driver-popover-description {
    font-weight: bold !important;
    color: #fff !important;
    font-size: 14px;
  }
  @keyframes scaleBoxShadow{
    0%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    25%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    50%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    75%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    100%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
  }`), options);
};

const closeDriver = () => resetDriversByNS(SCOPED_NAME, true);

const closeModuleGuide = (vue) => {
  const el = document.querySelector('#help_center_close-module-guide');
  if (!el) {
    return;
  }
  const currentCss = insertCurrentCss({ auto: true });
  const driver = createDriver(SCOPED_NAME, {
    className: currentCss,
    allowClose: false,
    opacity: 0.2,
    keyboardControl: false
  });

  const steps = [{
    element: '#help_center_close-module-guide',
    popover: {
      className: 'guide-card-close-popover',
      title: 'close',
      offset: 10,
      description: vue.$t('guide.saas.closeGuideDesc'),
      position: 'right-bottom',
      showButtons: true,
      closeBtnText: vue.$t('guide.button.know')
    },
    onHighlightStarted: () => {
      document.querySelector('#master-container').scrollIntoView();
      const helpCenterEl = document.querySelector('#help_center_close-module-guide');
      helpCenterEl.addEventListener('click', ()=>vue.driver.reset(), { once: true, capture: true });
    },
    onDeselected: () => {
      vue.setPageBackground(false);
    }
  }];

  driver.defineSteps(steps);
  return driver;
};

export default {
  data() {
    return {
      driver: null
    };
  },
  beforeDestroy() {
    this.clearDriver();
  },
  methods: {
    openCloseDriver() {
      this.eventBus.$emit('driver-show');
      const driver = closeModuleGuide(this);
      if (driver) {
        this.driver = driver;
        this.driver.start();
        this.setPageBackground(true);
      }
    },
    clearDriver() {
      closeDriver();
      this.driver = null;
    },
    // 更改背景颜色，显示层级下的导航栏
    setPageBackground(val) {
      const classes = ['.zk-resource-index', '.zk-roadmap-index', '.zk-release-index', '.setting-wrapper', '.zk-message'];
      classes.forEach(css => {
        const el = document.querySelector(css);
        el && (el.style.background = val ? 'unset' : '');
      });
    }
  }
};
